export const enGoldbet = {
  modal: {
    geolocation: {
      content: 'Goldbet.it is about to ask you to access your location for better use of the service',
      title: 'Geolocation Goldbet',
    },
  },
  namespaceTest: 'Hello goldbet',
};
